export function getOfflineRegistrationEventId(registration: unknown): number | null {
  if (typeof registration === 'number' && Number.isFinite(registration)) return registration;
  if (!registration || typeof registration !== 'object') return null;

  const item = registration as {
    id?: unknown;
    eventId?: unknown;
    masterEventId?: unknown;
    event?: { id?: unknown } | null;
  };
  const rawId = item.eventId ?? item.masterEventId ?? item.event?.id ?? item.id;
  return typeof rawId === 'number' && Number.isFinite(rawId) ? rawId : null;
}

export function getOfflineRegistrationIds(registrations: unknown[]): Set<number> {
  const ids = new Set<number>();
  registrations.forEach((registration) => {
    const id = getOfflineRegistrationEventId(registration);
    if (id != null) ids.add(id);
  });
  return ids;
}
